import React from "react";
import { Joystick } from "react-joystick-component";
import Config from "./Config";
import { useEffect } from "react";

const Teleoperation = () => {
  var rosSession;
  const init_connection = async function () {
    rosSession = await new window.ROSLIB.Ros();

    rosSession.on("connection", () => {
      console.log("Connection Established");
    });
    rosSession.on("close", () => {
      // Try to reconnect every 3 seconds
      setTimeout(() => {
        try {
          rosSession.connect(
            `ws://${Config.ROSBRIDGE_SERVER_IP}:${Config.ROSBRIDGE_SERVER_PORT}`
          );
        } catch (error) {
          console.log("Connection error");
        }
      }, Config.RECONNECTION_TIMER);
    });
    try {
      rosSession.connect(
        `ws://${Config.ROSBRIDGE_SERVER_IP}:${Config.ROSBRIDGE_SERVER_PORT}`
      );
    } catch (error) {
      console.log("Connection error");
    }
  };

  useEffect(() => {
    init_connection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleMove = (event) => {
    // We need to create a ros publisher on the topic cmd_vel
    var cmd_vel = new window.ROSLIB.Topic({
      ros: rosSession,
      name: Config.CMD_VEL_TOPIC,
      messageType: "geometry_msgs/Twist",
    });
    // We need to createa a twist message to be publish to ROSBridge
    var twist = new window.ROSLIB.Message({
      linear: {
        x: event.y / 50,
        y: 0,
        z: 0,
      },
      angular: {
        x: 0,
        y: 0,
        z: -event.x / 50,
      },
    });
    // We need to publish the message on cmd_vel topic.
    cmd_vel.publish(twist);
  };
  const handleStop = () => {
    // We need to create a ros publisher on the topic cmd_vel
    var cmd_vel = new window.ROSLIB.Topic({
      ros: rosSession,
      name: Config.CMD_VEL_TOPIC,
      messageType: "geometry_msgs/Twist",
    });
    // We need to createa a twist message to be publish to ROSBridge
    var twist = new window.ROSLIB.Message({
      linear: {
        x: 0,
        y: 0,
        z: 0,
      },
      angular: {
        x: 0,
        y: 0,
        z: 0,
      },
    });
    // We need to publish the message on cmd_vel topic.
    cmd_vel.publish(twist);
  };
  return (
    <div>
      <Joystick
        size={100}
        sticky={true}
        baseColor="#eeeeee"
        stickColor="#bbbbbb"
        move={handleMove}
        stop={handleStop}
      ></Joystick>
    </div>
  );
};

export default Teleoperation;
